var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8C9.10457 8 10 7.10457 10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6C6 7.10457 6.89543 8 8 8Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.47 5.83C14.882 4.30882 13.861 2.99331 12.5334 2.04604C11.2058 1.09878 9.62977 0.561286 8.00003 0.5C6.37029 0.561286 4.79423 1.09878 3.46663 2.04604C2.13904 2.99331 1.11811 4.30882 0.530031 5.83C0.490315 5.93985 0.490315 6.06015 0.530031 6.17C1.11811 7.69118 2.13904 9.00669 3.46663 9.95396C4.79423 10.9012 6.37029 11.4387 8.00003 11.5C9.62977 11.4387 11.2058 10.9012 12.5334 9.95396C13.861 9.00669 14.882 7.69118 15.47 6.17C15.5097 6.06015 15.5097 5.93985 15.47 5.83ZM8.00003 9.25C7.35724 9.25 6.72889 9.05939 6.19443 8.70228C5.65997 8.34516 5.24341 7.83758 4.99742 7.24372C4.75144 6.64986 4.68708 5.99639 4.81248 5.36596C4.93788 4.73552 5.24741 4.15642 5.70193 3.7019C6.15646 3.24738 6.73555 2.93785 7.36599 2.81245C7.99643 2.68705 8.64989 2.75141 9.24375 2.99739C9.83761 3.24338 10.3452 3.65994 10.7023 4.1944C11.0594 4.72886 11.25 5.35721 11.25 6C11.2487 6.86155 10.9059 7.68743 10.2967 8.29664C9.68746 8.90584 8.86158 9.24868 8.00003 9.25Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.248a3d4aeeeb9eff650c531f796122bf.svg";
export { ForwardRef as ReactComponent };